/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AssetsDataManagerGettingStartedEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const assetsDataManagerGettingStartedEntryPoint: EntryPoint<
	AssetsDataManagerGettingStartedEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsDataManagerGettingStartedEntryPointComponent>(
		/* webpackChunkName: "async-assets-data-manager-getting-started-page", jiraSpaEntry: "async-assets-data-manager-getting-started-page" */ './AssetsDataManagerGettingStartedPageSpa.tsx',
	),
	getPreloadProps: () => ({}),
});
